module.exports = __webpack_public_path__ + "img/feature-icon-06.28f4bec8.svg";